import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./en/translation.json";
import zh from "./zh/translation.json";
import es from "./es/translation.json";
import de from "./de/translation.json";
import zhTW from "./zh-TW/translation.json";
import zhHK from "./zh-HK/translation.json";
import ko from "./ko/translation.json";
import ja from "./ja/translation.json";

const resources = {
  en: {
    translation: en,
  },
  zh: {
    translation: zh,
  },
  es: {
    translation: es,
  },
  de: {
    translation: de,
  },
  "zh-TW": {
    translation: zhTW,
  },
  "zh-HK": {
    translation: zhHK,
  },
  ko: {
    translation: ko,
  },
  ja: {
    translation: ja,
  },
};

export const LANGUAGE_OPTIONS = [
  {
    value: "en",
    label: "English",
  },
  {
    value: "zh-CN",
    label: "简体中文",
  },
  // {
  //   value: "zh-TW",
  //   label: "繁體中文",
  // },
    {
    value: "zh-HK",
    label: "繁體中文",
  },
  // {
  //   value: "es",
  //   label: "Español",
  // },
  // {
  //   value: "de",
  //   label: "Deutsch",
  // },
  // {
  //   value: "ko",
  //   label: "Korean",
  // },
  // {
  //   value: "ja",
  //   label: "Japanese",
  // }
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: ["en", "zh", "es", "de", "zh-TW", "zh-HK", "ko", "ja"],
    fallbackLng: "zh-HK",
    ns: ["translation"],
    defaultNS: "translation",
    detection: {
      // URL 参数 > localStorage > 浏览器语言
      order: ["querystring", "localStorage", "navigator"],
      // URL 中的参数名
      lookupQuerystring: "lang",
      lookupLocalStorage: "i18nextLng",
      // caches: ["localStorage"], // 屏蔽i18n缓存逻辑
      caches: []
    },
    // 允许模糊匹配，如 zh-CN 匹配 zh
    nonExplicitSupportedLngs: true,
    // 生产环境关闭调试
    debug: import.meta.env.MODE !== "production",
    react: {
      useSuspense: false,
    },
  });

// 监听浏览器 lang 属性变化，切换 i18n 多语言
// window.addEventListener('load', () => {
//   const observer = new MutationObserver((mutations) => {
//     mutations.forEach((mutation) => {
//       if (mutation.attributeName === 'lang') {
//         i18n.changeLanguage(window.document.documentElement.lang);
//       }
//     });
//   });
//   observer.observe(window.document.documentElement, { attributeFilter: ['lang'] });
// })

export default i18n;
